import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { GeneralService } from '../services/general.service';
import { PermissionsService } from '../services/permissions.service';
import { StateService } from '../services/state.service';

export const permissionGuard: CanActivateFn = (route) => {
  const permissionsService = inject(PermissionsService);
  const stateService = inject(StateService);
  const router = inject(Router);
  const generalService = inject(GeneralService);

  const required = (route.data?.['requiredPermissions'] || []) as string[];
  if (!Array.isArray(required) || required.length === 0) return true;

  const companyId = stateService.selectedCompany?.['id'] || stateService.companyDetails?.['id'];
  if (!companyId) return true;

  return permissionsService.getPermissionsForCompany$(companyId).pipe(
    map((available) => {
      const hasAny = required.some((perm) => available.includes(perm));
      if (hasAny) return true;

      // The new-xxx pages get the full "no access" page; the older ones keep the toast.
      if (route.routeConfig?.path?.startsWith('new-')) return router.createUrlTree(['/new-no-access']);

      generalService.showToast("You don't have permission to access this page.", 'error', 'top');
      return router.createUrlTree(['/home']);
    }),
  );
};

